import { useState } from "react";
import { useRouteLoaderData } from "react-router-dom-v5-compat";
import { useOrdersQuery } from "../../../SWR/Orders/useOrdersQuery";
import { useSkipDaysQuery } from "../../../SWR/SkipDays/useSkipDaysQuery";
import { dateFilters } from "../../constants";
import { dateFilterLoadingText, itemsPerPage } from "../OrdersPage/orderUtils";
import { processOrders } from "./useOrder-utils";
/**
 *
 * @returns
 */
export const useOrders = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { accountSettings: { AccountSettings: { DisableUpdateDeliveryFeature } = {} } = {} } = useRouteLoaderData("root-loader");
    // the current page number for paginated orders
    const [pageNumber, setPageNumber] = useState(1);
    // the current date filter state
    const [dateFilter, setDateFilter] = useState(dateFilters.upcoming);
    //* SWR SKIP DAYS QUERY
    const { skippedDays, error: SWR_SkipDays_Error } = useSkipDaysQuery();
    //* SWR ORDERS QUERIES
    const { upcomingOrdersQueryResponse, ordersByDateQueryResponse, triggerOrderUpdate, // SWR mutation hook for updating order pickup/delivery
    isMutating, } = useOrdersQuery(pageNumber, dateFilter, itemsPerPage);
    // determine which data to deliver to the ordes componenent based on the current dateFilter state
    const ORDERS_DATA = dateFilter === dateFilters.upcoming ? upcomingOrdersQueryResponse : ordersByDateQueryResponse;
    const { data, isLoading, isValidating, error: SWR_Orders_Error } = ORDERS_DATA;
    // build a config object based on the query response
    // TODO Company configs should be moved to a company config provider/context instead
    const SWR_Orders_CompanyConfig = {
        companyText: (_a = data === null || data === void 0 ? void 0 : data.companyConfig) === null || _a === void 0 ? void 0 : _a.companyText,
        skipPayments: (_b = data === null || data === void 0 ? void 0 : data.companyConfig) === null || _b === void 0 ? void 0 : _b.skipPayment,
        showPriceIfZero: (_c = data === null || data === void 0 ? void 0 : data.companyConfig) === null || _c === void 0 ? void 0 : _c.showPricesIfZero,
        startSunday: data === null || data === void 0 ? void 0 : data.startSunday,
        deliveryModalPickupDescription: (_d = data === null || data === void 0 ? void 0 : data.companyConfig) === null || _d === void 0 ? void 0 : _d.deliveryModalPickupDescription,
        deliveryModalDeliveryDescription: (_e = data === null || data === void 0 ? void 0 : data.companyConfig) === null || _e === void 0 ? void 0 : _e.deliveryModalDeliveryDescription,
    };
    // collect additional data based on query response
    const SWR_Orders_NumTotalOrders = (data === null || data === void 0 ? void 0 : data.numTotalOrders) || ((_f = data === null || data === void 0 ? void 0 : data.orders) === null || _f === void 0 ? void 0 : _f.length);
    const SWR_Orders_DateFilterLoadingText = dateFilterLoadingText(dateFilter);
    const SWR_Orders_CurrentOrders = ((_g = data === null || data === void 0 ? void 0 : data.orders) === null || _g === void 0 ? void 0 : _g.length) > 0 ? processOrders(data === null || data === void 0 ? void 0 : data.orders, dateFilter) : [];
    // ===== CONDITIONAL RENDERING =====
    const errorMessage = (SWR_Orders_Error === null || SWR_Orders_Error === void 0 ? void 0 : SWR_Orders_Error.message) || SWR_SkipDays_Error || "";
    const swrIsLoading = isLoading || isMutating;
    const showError = !swrIsLoading && !!errorMessage;
    const showNoOrders = !swrIsLoading && !errorMessage && !(SWR_Orders_CurrentOrders === null || SWR_Orders_CurrentOrders === void 0 ? void 0 : SWR_Orders_CurrentOrders.length);
    const showOrders = !swrIsLoading && !errorMessage && !!(SWR_Orders_CurrentOrders === null || SWR_Orders_CurrentOrders === void 0 ? void 0 : SWR_Orders_CurrentOrders.length);
    const showPagination = !!(SWR_Orders_CurrentOrders === null || SWR_Orders_CurrentOrders === void 0 ? void 0 : SWR_Orders_CurrentOrders.length) && SWR_Orders_NumTotalOrders > itemsPerPage;
    return {
        companyConfig: SWR_Orders_CompanyConfig,
        currentOrders: SWR_Orders_CurrentOrders,
        dateFilter,
        DisableUpdateDeliveryFeature,
        error: errorMessage,
        loadingText: SWR_Orders_DateFilterLoadingText,
        numTotalOrders: SWR_Orders_NumTotalOrders,
        pageNumber,
        setDateFilter,
        setPageNumber,
        showError,
        showNoOrders,
        showOrders,
        showPagination,
        skippedDays,
        swrIsLoading,
        updateFunction: triggerOrderUpdate,
    };
};
